// extracted by mini-css-extract-plugin
export var banner = "_mp-0";
export var settingRow = "_mp-2";
export var titleIcon = "_mp-1";